module.exports = __webpack_public_path__ + "img/标准文件7.572c3280.png";